import React, { useEffect, useState } from 'react';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Reviews from './pages/Reviews';
import Contact from './pages/Contact';
import AdminPanel from './components/AdminPanel';
import './App.css';

function App() {
  const [showAdmin, setShowAdmin] = useState(false);

  // URL hash değişikliklerini dinle (gizli admin erişimi için)
  useEffect(() => {
    const checkHash = () => {
      const hash = window.location.hash.substring(1); // # işaretini kaldır
      if (hash === 'admin') {
        setShowAdmin(true);
        // Scroll işlemi için kısa bir gecikme
        setTimeout(() => {
          const element = document.getElementById('admin');
          if (element) {
            const offset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      } else {
        setShowAdmin(false);
      }
    };

    // Sayfa yüklendiğinde hash kontrolü
    checkHash();

    // Hash değişikliklerini dinle
    window.addEventListener('hashchange', checkHash);
    
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);

  return (
    <div className="App">
      <Navigation />
      <section id="anasayfa">
        <Home />
      </section>
      <section id="galeri">
        <Gallery />
      </section>
      <section id="yorumlar">
        <Reviews />
      </section>
      <section id="iletisim">
        <Contact />
      </section>
      {showAdmin && (
        <section id="admin">
          <AdminPanel />
        </section>
      )}
    </div>
  );
}

export default App;

